export default __webpack_public_path__ + "static/media/minus.a7cd5b98.svg";